export enum CustomerFlow {
  Base = 'base',
  CarTrip = 'carTrip',
  FlightOnlyFromMarketplace = 'flightOnlyFromMarketplace',
  InfiniteLoadReload = 'infiniteLoadReload',
  MetaHotel = 'metaHotel',
}
